import axios from 'axios';

function usePlatformAPI() {
  function loadPlatformSupportFromRemote() {
    const url = `/vbeta2/platform/support`;

    return axios({
      url,
      method: 'get',
      responseType: 'json',
    });
  }

  return {
    loadPlatformSupportFromRemote,
  };
}

export { usePlatformAPI };
